import api from "@cx/http"; // eslint-disable-line no-restricted-imports
import { getMicolashApiConfig } from "../util/apiConfigHelper";

export function getSecretKey(userToken) {
  const { get } = api(getMicolashApiConfig());
  return get("secret/" + userToken);
}
